// Module
var code = "<div class=\"block-11__quote-wrapper quote bc-blue\"> <div class=\"block-11__quote quote\"></div> </div> <div class=\"block-11__image-large image\"></div> ";
// Exports
export default code;